import {Dialog, DialogTitle} from '@priority-software/priority-style-react';
import React from 'react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {Footer} from './Footer';
import styles from '../styles.module.scss';
import Editor from './Editor';

interface Props {
    isOpen: boolean;
    htmlValue: string;
    onChangeHtmlValue(value: string): void;
    onSave(): void;
    onClose(): void;
}

const RTEDialog = ({isOpen, htmlValue, onChangeHtmlValue, onSave, onClose}: Props) => (
    <Dialog
        componentClasses={styles.rteDialog}
        width={980}
        isOpen={isOpen}
        onClose={onClose}
        title={
            <DialogTitle
                title={getLocalizedText(texts.AddRemarks)}
                size="large"
                textColor="primary-700"
            />
        }
        content={<Editor value={htmlValue} onChange={onChangeHtmlValue} />}
        footer={<Footer onSave={onSave} onCancel={onClose} />}
    />
);

export default RTEDialog;
